module.exports = __webpack_public_path__ + "img/Dilu_Pereda.7a63d144.webp";